interface LineSelectableFieldConfig {
  isSelected: boolean;
  key: string;
}

export class LineSelectableFields {
  salesOrderNumber?: LineSelectableFieldConfig = undefined;
  requestedReceiptDate?: LineSelectableFieldConfig = undefined;
  itemNumber?: LineSelectableFieldConfig = undefined;
  description?: LineSelectableFieldConfig = undefined;
  sizeCode?: LineSelectableFieldConfig = undefined;
  quantityShipped?: LineSelectableFieldConfig = undefined;
  quantityCancelled?: LineSelectableFieldConfig = undefined;
  quantityOrdered?: LineSelectableFieldConfig = undefined;
  eanNumber?: LineSelectableFieldConfig = undefined;
  wholesalePrice?: LineSelectableFieldConfig = undefined;
  orderLineStatus?: LineSelectableFieldConfig = undefined;
  translotId?: LineSelectableFieldConfig = undefined;
  brand?: LineSelectableFieldConfig = undefined;
  selection?: LineSelectableFieldConfig = undefined;
  vertical?: LineSelectableFieldConfig = undefined;
  fabricCode?: LineSelectableFieldConfig = undefined;
  gender?: LineSelectableFieldConfig = undefined;
  defaultItemGroup?: LineSelectableFieldConfig = undefined;
  fabricDescription?: LineSelectableFieldConfig = undefined;
  nrfColor?: LineSelectableFieldConfig = undefined;
  primaryColor?: LineSelectableFieldConfig = undefined;
  fedas?: LineSelectableFieldConfig = undefined;
  usSize?: LineSelectableFieldConfig = undefined;
  euSize?: LineSelectableFieldConfig = undefined;
  jpSize?: LineSelectableFieldConfig = undefined;
  brSize?: LineSelectableFieldConfig = undefined;
  ukSize?: LineSelectableFieldConfig = undefined;
  nrfSize?: LineSelectableFieldConfig = undefined;
  phaseInDate?: LineSelectableFieldConfig = undefined;
  phaseOutDate?: LineSelectableFieldConfig = undefined;
  countryOfOrigin?: LineSelectableFieldConfig = undefined;
  advertisedOrigin?: LineSelectableFieldConfig = undefined;
  customsTariffNumber?: LineSelectableFieldConfig = undefined;
  retailerPrice?: LineSelectableFieldConfig = undefined;
  productMaterialDescription?: LineSelectableFieldConfig = undefined;
  defaultItemGroupUpperUnit?: LineSelectableFieldConfig = undefined;
  defaultItemGroupBottomUnit?: LineSelectableFieldConfig = undefined;
  defaultItemGroupMembrane?: LineSelectableFieldConfig = undefined;
  widthStandard?: LineSelectableFieldConfig = undefined;
  heelToeDrop?: LineSelectableFieldConfig = undefined;
  defaultItemGroupMaterialComposition?: LineSelectableFieldConfig = undefined;
  defaultItemGroupProductMaterialComposition?: LineSelectableFieldConfig = undefined;
  defaultItemGroupHighlightedFeaturesOfGarment?: LineSelectableFieldConfig = undefined;
  engMarketingDescription?: LineSelectableFieldConfig = undefined;
  deMarketingDescription?: LineSelectableFieldConfig = undefined;
  frMarketingDescription?: LineSelectableFieldConfig = undefined;
  nlMarketingDescription?: LineSelectableFieldConfig = undefined;
  espMarketingDescription?: LineSelectableFieldConfig = undefined;
  jpMarketingDescription?: LineSelectableFieldConfig = undefined;
  ptMarketingDescription?: LineSelectableFieldConfig = undefined;
  marketingColor?: LineSelectableFieldConfig = undefined;
  consumerPackageHeight?: LineSelectableFieldConfig = undefined;
  consumerPackageLength?: LineSelectableFieldConfig = undefined;
  consumerPackageWidth?: LineSelectableFieldConfig = undefined;
  weightGrams?: LineSelectableFieldConfig = undefined;
  netWeightOunces?: LineSelectableFieldConfig = undefined;
  defaultItemGroupUnitOfMeasure?: LineSelectableFieldConfig = undefined;
  defaultItemGroupRecordType?: LineSelectableFieldConfig = undefined;
  season?: LineSelectableFieldConfig = undefined;
}

export type LineSelectableFieldsKeys = keyof LineSelectableFields;

export const defaultSelectedLineFields: Set<LineSelectableFieldsKeys> = new Set([
  'salesOrderNumber',
  'requestedReceiptDate',
  'itemNumber',
  'description',
  'sizeCode',
  'quantityShipped',
  'quantityCancelled',
  'quantityOrdered',
  'eanNumber',
  'wholesalePrice',
  'orderLineStatus',
  'translotId',
]);

export const disabledFieldsForDistributor = new Set<LineSelectableFieldsKeys>([
  'wholesalePrice',
  'retailerPrice',
  'season',
]);
